import { Component } from '@angular/core';
import { breadcrumb, link, stat } from '../../layout/header/header.component';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { DataService } from 'src/app/services/data.service';

import { TranslatorPipe } from 'src/app/services/translator.pipe';


@Component({
  selector: 'app-dashboards',
  templateUrl: './dashboards.component.html',
  styleUrls: ['./dashboards.component.scss']
})
export class DashboardsComponent {


  translator:TranslatorPipe = new TranslatorPipe()

  header = this.translate('Data panel');
  links: link[] = [
    // {
    //   name: 'Add New',
    //   icon: 'pi pi-plus',
    //   link: '/admin/dashboards/add',
    //   visible: this.permissionService.hasPermission('DATA', 'c'),
    // },
  ];
  breadcrumbs: breadcrumb[] = [{ name: this.translate('Data panel'), link: '/admin/dashboard' }];
  stats: stat[] = [
  ];

  dashboards: any;
  skelition: boolean = true;
  dashboards_names: any = ["1", "2"];

  activeIndex: number = 0;
  currentdata: any[] = [];

  allowedTags: string[] = this.permissionService.extractTags('GRAPHS', 'a')

  managerOu: any;
  ousData: any;

  constructor( public permissionService: PermissionHandlerService, private dataService: DataService, ) {}

  ngOnInit() {

    this.managerOu = localStorage.getItem('managerOus');

    this.managerOu = this.managerOu ? JSON.parse(this.managerOu) : null

    if(this.managerOu && this.managerOu.length > 0) {
      this.allowedTags.push('MANAGER');
    }

    if (this.permissionService.hasPermission('USER_MANAGEMENT', 'r')) {
      this.allowedTags.push('ADMIN');
    }

    Promise.all([
      this.getDashboards(),
      this.getOUdata(this.managerOu)
    ]).then(() => {
      this.onTabClick(this.activeIndex);
      this.skelition = false
    })
  }
  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  private async getDashboards(): Promise<void> {

    let res = await this.dataService.postData('dashboards/unique-names', {
      data: this.allowedTags,
    });
    if (res.error) {
      return;
    }
    console.log('this is the reply', res);
    this.dashboards_names = res.data;
  }

  async getDashboard_by_name(name: string): Promise<any[]> {
    let res = await this.dataService.postData('dashboards/query', {
      'query': {
        'name': name,
        'tag': { '$in': this.allowedTags }
      }
    }); 

    return res.data;
  }

  async getOUdata(data: string[]) {
    let resArray: any = [];
    if(data && data.length > 0) {
      await data.forEach(async (ou: string) => {
        let res = await this.dataService.getData(
          'ou/getByOuId?id=' + ou
        );
        res.data[0].breadcrumbs.sort((a: { depth: number; },b: { depth: number; }) => b.depth - a.depth);
        resArray.push(res.data[0]);
      })

      console.log("resArray =>  ", resArray);
      this.ousData = resArray;
    }
  }
  
  async onTabClick(arg0: number) {
    console.log(arg0);
    this.currentdata = await this.getDashboard_by_name(this.dashboards_names[arg0])
    this.currentdata.sort((a, b) => a.sort - b.sort);
  }


}
